/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FaceAHappyIcon20Solid = forwardRef('FaceAHappyIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm4.763-6.724a.875.875 0 1 0-1.69-.453 3.18 3.18 0 0 1-6.146 0 .875.875 0 1 0-1.69.453 4.931 4.931 0 0 0 9.526 0Z" })));
});
